<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Limites (ICC)</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
              v-b-tooltip.hover.bottom
              title="Filtros"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Limites</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="text-left border-0">Cliente</th>
                    <th scope="col" class="text-left border-0">Marketplace</th>
                    <th scope="col" class="border-0">TrustLevel</th>
                    <th scope="col" class="border-0">Percentual antecipação</th>
                    <th scope="col" class="border-0">Valor/operações diárias</th>
                    <th scope="col" class="border-0">Valor/operações mensais</th>
                    <th scope="col" class="border-0">Ticket médio</th>
                    <th scope="col" class="border-0">Data de alteração</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(merchantLimits, index) in merchantLimits"
                    :key="index"
                  >
                    <td class="text-left">
                      <div>
                        {{ merchantLimits.Merchant.Name | substring(50) }} [{{
                          merchantLimits.Merchant.Id
                        }}]
                      </div>
                      <span class="td-span-style">{{
                        merchantLimits.Merchant.Identity | identity
                      }}</span>
                    </td>
                    <td class="text-left" v-if="merchantLimits.Merchant.IdMerchantRoot > 0">
                      <div>
                        {{
                          merchantLimits.Merchant.NameMerchantRoot
                            | substring(50)
                        }}
                        [{{ merchantLimits.Merchant.IdMerchantRoot }}]
                      </div>
                      <span class="td-span-style">{{
                        merchantLimits.Merchant.IdentityMerchantRoot | identity
                      }}</span>
                    </td>
                    <td v-else>
                      <i class="fas fa-minus"></i>
                    </td>
                    <td>{{ merchantLimits.Merchant.TrustLevel }}</td>
                    <td>
                      {{ merchantLimits.MaxAdvancePercentage | percentage }}
                    </td>
                    <td>
                      <div>{{ merchantLimits.MaxDailyAmount | currency }}</div>
                      <span class="td-span-style">
                        {{ merchantLimits.MaxDailyOperations }}
                      </span>
                    </td>
                    <td>
                      <div>
                        {{ merchantLimits.MaxMonthlyAmount | currency }}
                      </div>
                      <span class="td-span-style">
                        {{ merchantLimits.MaxMonthlyOperations }}
                      </span>
                    </td>
                    <td>{{ merchantLimits.MaxTicketAmount | currency }}</td>
                    <td>{{ merchantLimits.LastCheckDate | date }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary"
                          type="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                          v-on:click="
                            OpenModalLimits(merchantLimits.Merchant.IdLimits)
                          "
                        >
                          Visualizar
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      merchantLimits == undefined ||
                      merchantLimits == null ||
                      merchantLimits.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Código</label>
          <input
            type="text"
            class="form-control"
            v-model="filter.Id"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <label>{{labelName}}</label>
          <input
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <label>{{labelIdentity}}</label>
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetModalFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <!-- Limite -->
    <b-modal
      size="lg"
      id="mFormLimits"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">Visualizar</h5>
        <button class="close" @click="HideModalLimits()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingLimits"></loader>

      <!-- Dados: limites (default do trustlevel do merchant) -->
      <div>
        <h4>Limites</h4>
        <hr />
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Percentual máximo de antecipação</label>
            <decimal-field
              class="form-control"
              v-model="infoLimits.MaxAdvancePercentage"
              type="percentage"
              :maxDecimalPlaces="0"
              disabled
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Valor máximo de ticket</label>
            <currency-input
              v-model="infoLimits.MaxTicketAmount"
              class="form-control"
              disabled
            />
          </d-col>
        </d-form-row>
        <h5>Diário</h5>
        <hr />
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Valor máximo</label>
            <currency-input
              v-model="infoLimits.MaxDailyAmount"
              class="form-control"
              disabled
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Número de operações máximas</label>
            <div class="input-group">
              <d-form-input
                type="number"
                min="0"
                step="1"
                v-model="infoLimits.MaxDailyOperations"
                disabled
              />
            </div>
          </d-col>
        </d-form-row>
        <h5>Mensal</h5>
        <hr />
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Valor máximo</label>
            <currency-input
              v-model="infoLimits.MaxMonthlyAmount"
              class="form-control"
              disabled
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Número de operações máximas</label>
            <d-form-input
              type="number"
              v-model="infoLimits.MaxMonthlyOperations"
              disabled
            />
          </d-col>
        </d-form-row>

        <br/>
        <h4>Corrente</h4>
        <hr />
        <h5>Diário</h5>
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Valor máximo</label>
            <currency-input
              v-model="infoLimits.MaxDailyAmount"
              class="form-control"
              disabled
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Número de operações máximas</label>
            <div class="input-group">
              <d-form-input
                type="number"
                min="0"
                step="1"
                v-model="infoLimits.MaxDailyOperations"
                disabled
              />
            </div>
          </d-col>
        </d-form-row>
        <h5>Mensal</h5>
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Valor máximo</label>
            <currency-input
              v-model="infoLimits.MaxMonthlyAmount"
              class="form-control"
              disabled
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Número de operações máximas</label>
            <d-form-input
              type="number"
              v-model="infoLimits.MaxMonthlyOperations"
              disabled
            />
          </d-col>
        </d-form-row>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import decimalField from "../common/decimal-field.vue";
export default {
  name: "merchantLimits",
  components: {
    decimalField,
  },
  data: function () {
    return {
      loadingList: false,
      loadingLimits: false,
      loadingModal: false,
      countFilter: 0,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Id: null,
        Name: null,
        Identity: null,
      },
      pOpened: null,
      infoLimits: {
        MaxAdvancePercentage: null,
        MaxDailyAmount: null,
        MaxMonthlyAmount: null,
        MaxDailyOperations: null,
        MaxMonthlyOperations: null,
        MaxTicketAmount: null,
        LastCheckDate: null,
      },
      merchantLimits: [],
      infoMerchantLimits: {
        Merchant: {
          Id: null,
          Name: null,
          Identity: null,
          IdLimits: null,
          TrustLevel: null,
          IdMerchantRoot: null,
          NameMerchantRoot: null,
          IdentityMerchantRoot: null,
        },
        MaxAdvancePercentage: null,
        MaxDailyAmount: null,
        MaxMonthlyAmount: null,
        MaxDailyOperations: null,
        MaxMonthlyOperations: null,
        MaxTicketAmount: null,
        LastCheckDate: null,
      },
      labelIdentity: "CPF/CNPJ",
      labelName: "Cliente",
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListMerchantLimits();
    },
    "pagination.RowsPerPage": function () {
      this.ListMerchantLimits();
    },
  },
  mounted() {
    this.ListMerchantLimits();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListMerchantLimits();
    },
    ResetInfoMerchantLimits: function () {
      this.infoMerchantLimits = {
        Merchant: {
          Id: null,
          Name: null,
          Identity: null,
          TrustLevel: null,
          IdLimits: null,
          IdMerchantRoot: null,
          NameMerchantRoot: null,
          IdentityMerchantRoot: null,
        },
        MaxAdvancePercentage: null,
        MaxDailyAmount: null,
        MaxMonthlyAmount: null,
        MaxDailyOperations: null,
        MaxMonthlyOperations: null,
        MaxTicketAmount: null,
        LastCheckDate: null,
      };
    },
    GetLimits: function (id) {
      if (this.trustLevel != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetLimits", { id: id })
          .then((response) => {
            this.infoLimits = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar o limite",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListMerchantLimits: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Id)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Id": this.filter.Id,
          "Object.Merchant.Name": this.filter.Name,
          "Object.Merchant.Identity": this.filter.Identity,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListMerchantLimits", { params: data })
        .then((response) => {
          this.merchantLimits = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as áreas",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        Id: null,
        Name: null,
        Identity: null,
      };
      this.ListMerchantLimits();
    },
    ResetModalFilter: function () {
      this.filter = {
        Id: null,
        Name: null,
        Identity: null,
      }
    },
    OpenModalLimits: function (id) {
      this.GetLimits(id);
      this.$bvModal.show("mFormLimits");
    },
    HideModalLimits: function () {
      this.$bvModal.hide("mFormLimits");
    },
  },
};
</script>
<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/merchantLimits.vue